import { createRouter, createWebHashHistory } from "vue-router";
import Home from "@/views/home/index.vue";
import WarningInfo from "@/views/waring-info/index.vue";

const routes = [
  {
    path: "/",
    name: "dashboard-home",
    component: Home,
  },
  {
    path: "/home",
    name: "home",
    component: Home,
  },
  {
    path: "/waring-info",
    name: "warning-info",
    component: WarningInfo,
  },
  {
    path: "/device-status",
    name: "device-status",
    component: () => import("@/views/device-status/index.vue"),
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
